import { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";

export const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "messages"), {
        ...formData,
        submittedAt: Timestamp.now(),
      });
      alert("✅ Message sent!");
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      console.error("Error submitting message:", err);
      alert("❌ Could not send message. Please try again.");
    }
  };

  return (
    <section id="Contact" className="py-20 px-4 bg-gray-100">
      <h2 className="text-4xl font-bold text-center text-blue-900 mb-10">Contact Us</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto">
        <form onSubmit={handleSubmit} className="space-y-4 bg-white p-8 shadow-lg rounded-xl">
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-md"
            placeholder="Name"
            required
          />
          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-md"
            placeholder="Email"
            required
          />
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-md"
            rows="4"
            placeholder="Your Message"
            required
          />
          <button type="submit" className="w-full bg-blue-800 text-white py-3 rounded-md font-semibold hover:bg-blue-700 transition">
            Send Message
          </button>
        </form>

        <div className="flex flex-col justify-between">
          <iframe
            title="Google Map"
            src="https://maps.google.com/maps?q=20%20Tangreen%20Ct%2C%20North%20York%2C%20ON%20M2M%203Y9&z=15&output=embed"
            className="w-full h-64 rounded shadow"
          ></iframe>
          <div className="mt-4 text-gray-700 text-sm sm:text-base">
            <p><strong>Email:</strong> info@psatoronto.net</p>
            <p><strong>Phone:</strong> +1 (647) 544-1344</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
